import { Screen } from '@betty/navigation';
import PlayWithCoinsBanner from '../../components/PlayWithCoinsBanner/PlayWithCoinsBanner';
import { useSelector } from '@betty/toolkit/state';
import { selectCoinGameIds } from '../../state';
import GamesGrid from '../../components/GamesGrid/GamesGrid';

function PlayWithCoinsScreen() {
  const coinGameids = useSelector(selectCoinGameIds);
  return (
    <Screen paddingHorizontal="space-0">
      <GamesGrid
        gameIds={coinGameids}
        ListHeaderComponent={PlayWithCoinsBanner}
        contentContainerStyle={{
          paddingBottom: 'safe-area-inset-bottom',
        }}
        imageType="custom"
        currencyCode="BTY"
      />
    </Screen>
  );
}

export default PlayWithCoinsScreen;
